/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2019-01-21 04:46:05
 * @Last Modified by:   syyoon@yongtrim.com
 * @Last Modified time: 2019-01-21 04:46:05
 */

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { TransService } from "./trans.service";

@Injectable()
export class PayLogService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/pay-logs`;

  constructor(private transService: TransService, private http: HttpClient) {}

  getPayLogs(page: number) {
    return this.http.get(
      `${this.url}?page=${page}&lang=${this.transService.lang}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/pay-log.service.ts